module.exports = __webpack_public_path__ + "static/media/provicequote.7559dace.png";